import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface OrgDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (input: { key: string; name: string }) => void;
  isSubmitting?: boolean;
  error?: string;
}

export function OrgDialog({
  open,
  onOpenChange,
  onSubmit,
  isSubmitting,
  error,
}: OrgDialogProps) {
  const [key, setKey] = useState('');
  const [name, setName] = useState('');

  useEffect(() => {
    if (!open) {
      setKey('');
      setName('');
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create partner organisation</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="org-name">Display name</Label>
            <Input
              id="org-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Musgrave Group"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="org-key">Key</Label>
            <Input
              id="org-key"
              value={key}
              onChange={(e) => setKey(e.target.value.toLowerCase())}
              placeholder="musgrave"
            />
            <p className="text-xs text-muted-foreground">
              Lowercase identifier used in portal context (letters, numbers, hyphens).
            </p>
          </div>
          {error ? <p className="text-sm text-red-600">{error}</p> : null}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            onClick={() => onSubmit({ key, name })}
            disabled={isSubmitting || !key.trim() || !name.trim()}
          >
            Create
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
